import Styled from "styled-components";

 export const Img=Styled.img
` height: 400px;
width: 100%;
// float: left;
//  margin-right: -100%;
//   position: relative; 
//   opacity: 1; 
//   display: block;
//    z-index: 2;`

